<template>
  <client-only>
    <vk-modal selenium="job-detail-modal" @close="close">
      <vk-modal-body>
        <vk-modal-header class="text-center text-bold p-l-6">
          <span v-if="workOrder">
            {{ workOrder.service_display_name }}
          </span>
        </vk-modal-header>
        <vk-modal-content class="p-0">
          <job-details v-if="workOrder" :job-id="jobId">
            <template slot="pre">
              <detail-item
                  item-label="Customer Timeframe"
                  item-selenium="triage-urgency-subcontainer"
                  selenium="triage-urgency-container"
              >
                <template slot="value">
                  <div selenium="triage-urgency">
                    {{ urgency }}
                  </div>
                  <div selenium="triage-created-on" class="text-md c-gray60">
                    Created {{ new Date(workOrder.time_created) | timeReceivedJobs }}
                  </div>
                </template>
              </detail-item>
            </template>
          </job-details>
        </vk-modal-content>
      </vk-modal-body>
    </vk-modal>
  </client-only>
</template>

<script>
import workOrder from '@/mixins/work-order';
import JobDetails from '@/components/JobDetails';
import DetailItem from '@/components/DetailsList/DetailItem';

export default {
  name: 'triage-details',
  components: {
    JobDetails,
    DetailItem,
  },
  mixins: [
    workOrder,
  ],
  props: {
    // Used by workOrder mixin
    jobId: {
      type: String,
      required: true,
    },
  },
  async created () {
    try {
      await this.fetchWorkOrder({ jobId: this.jobId });
    } catch (error) {
      this.close();
      console.error(error); // eslint-disable-line no-console
    }
  },
  methods: {
    close () {
      this.$router.push({ name: 'consumer::dashboard' });
    },
  },
};
</script>
